import * as types from "../constants/actionTypes";

export const setSelectedOption = selectedOption => {
  return {
    type: types.UPDATE_SELECTED_OPTION,
    payload: selectedOption
  };
};



// WEBPACK FOOTER //
// ./src/actions/selectedOptionActions.js